// aifab - Sidebar with project switcher
import { NAV } from '../../constants/nav';

// Normalise brand strings regardless of what DB returns
const normBrand = (s) => {
  if (!s) return s;
  return s
    .replace(/AIIOP\.AI/gi, 'aiiop.ai')
    .replace(/AIIOP/gi, 'aiiop')
    .replace(/Aiiop\.ai/g, 'aiiop.ai')
    .replace(/Aiiop/g, 'aiiop');
};

export function Sidebar({ projects: projectsProp, page, onNavigate, user, onLogout, projectId, onProjectChange }) {
  const projects = projectsProp ?? null;
  const userRole = user?.role || '';
  const canSee = (item) => {
    if (!item.minRole) return true;
    if (item.minRole === 'ORG_ADMIN') return ['ADMIN','ORG_ADMIN'].includes(userRole);
    if (item.minRole === 'ADMIN')     return userRole === 'ADMIN';
    return true;
  };
  const visibleNav = NAV.filter(canSee);
  const sections = [...new Set(visibleNav.map(n => n.section))];
  const initials = user?.full_name
    ? user.full_name.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase()
    : (user?.email?.[0] || 'U').toUpperCase();

  return (
    <div className="sidebar">
      {/* Logo */}
      <div className="sidebar-logo">
        <div className="logo-name">
          <span className="logo-aiiop">aiiop</span>
          <span className="logo-fabric"> Fabric</span>
        </div>
      </div>

      {/* Project switcher */}
      <div className="proj-switcher">
        <select
          className="proj-select"
          value={projectId || ''}
          onChange={e => onProjectChange(e.target.value)}
        >
          <option value="">- All Projects -</option>
          {(projects || []).map(p => (
            <option key={p.id} value={p.id}>{p.project_name}</option>
          ))}
        </select>
      </div>

      {/* Navigation */}
      <nav className="nav">
        {sections.map((section, si) => (
          <div key={section}>
            <div className="nav-section" style={si > 0 ? { marginTop: 6 } : undefined}>
              {section}
            </div>
            {visibleNav.filter(n => n.section === section).map(n => (
              <div
                key={n.key}
                className={`nav-item${page === n.key ? ' active' : ''}`}
                onClick={() => onNavigate(n.key)}
              >
                <span className="nav-icon">{n.icon}</span>
                {n.label}
              </div>
            ))}
          </div>
        ))}
      </nav>

      {/* User footer */}
      <div className="sidebar-footer">
        <div className="user-row" onClick={onLogout} title="Sign out">
          <div className="user-avatar">{initials}</div>
          <div className="user-info">
            <div className="user-email" style={{ fontWeight: 600 }}>
              {user?.full_name || user?.email}
            </div>
            <div className="flex gap4" style={{ marginTop: 2 }}>
              <span className="user-role">{normBrand(user?.org_name) || 'aiiop.ai'}</span>
              {user?.role && (
                <span className={`badge ${
                  user.role === 'ADMIN' ? 'b-or' :
                  user.role === 'ML_ENGINEER' ? 'b-green' : user.role === 'DATA_ENGINEER' ? 'b-blue' : 'b-gray'
                }`} style={{ fontSize: 8, padding: '1px 4px' }}>
                  {user.role}
                </span>
              )}
            </div>
          </div>
          <span className="sidebar-signout">⇥</span>
        </div>
      </div>
    </div>
  );
}
